export function Page404() {
  return 'Page not found!';
}
